import { createContext, useContext } from 'react'

interface SuperAdminShellContextValue {
  onMenuToggle: () => void
}

export const SuperAdminShellContext = createContext<SuperAdminShellContextValue>({
  onMenuToggle: () => {},
})

export function useMenuToggle() {
  return useContext(SuperAdminShellContext)
}
